import { List } from '../List'

export class PeerReviewedPublicationParent extends List {
  constructor(obj) {
    super(PeerReviewedPublication, obj)
  }
}

export class PeerReviewedPublication {
  constructor() {
    this.id = null
    this.commonWork = null
    this.vac = null
    this.doi = null
    this.tome = null
    this.magazineNumber = null
    this.page = null
    this.fullBibliographicDescription = null
    this.partNumber = null
    this.publicationOutput = null
    this.isForeign = null
    this.isVac = false
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork,
      vac: this.vac,
      doi: this.doi,
      tome: this.tome,
      magazineNumber: this.magazineNumber,
      page: this.page,
      fullBibliographicDescription: this.fullBibliographicDescription,
      partNumber: this.partNumber,
      publicationOutput: this.publicationOutput,
      isForeign: this.isForeign,
      isVac: this.isVac
    }
  }

  static buildFromAPI(obj) {
    const _this = new PeerReviewedPublication()
    if (obj) {
      _this.id = obj.id
      _this.commonWork = obj.commonWork
      _this.vac = obj.vac
      _this.doi = obj.doi
      _this.tome = obj.tome
      _this.magazineNumber = obj.magazineNumber
      _this.page = obj.page
      _this.fullBibliographicDescription = obj.fullBibliographicDescription
      _this.partNumber = obj.partNumber
      _this.publicationOutput = obj.publicationOutput
      _this.isForeign = obj.isForeign
      _this.isVac = obj.isVac
    }
    return _this
  }
}
